import { useState, useEffect } from 'react';
import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export interface MediaUploadCount {
    count: string;
    org_id: number;
    name: string; // Organization name
    activation_name: string; // The name field from the activations table
}

export default function useMediaUploadCounts(days: number = 60) {
    const [data, setData] = useState<MediaUploadCount[] | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const api = useAuthenticatedApi();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await api.get(
                    '/photo-engineers/media-upload-counts-by-activation',
                    {
                        params: { days },
                    },
                );
                setData(response.data);
            } catch (error) {
                console.error('Error fetching media upload counts:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [api, days]);

    return { data, isLoading };
}
